(function () {
  const block = {
    $blocks: document.querySelectorAll('section.tjh_what_happens_next'),
    $activeBlocks: new Set(),
    observer: null,
    ticking: false,
    isListening: false,

    init() {
      if (!this.$blocks.length) return;

      this.setUpListeners();
    },

    setUpListeners() {
      this.onScroll = () => this.requestProgressUpdate();
      this.onResize = () => this.requestProgressUpdate();

      if (!('IntersectionObserver' in window)) {
        this.addProgressListeners();
        this.updateProgress(this.$blocks);
        return;
      }

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          this.updateBlockProgress(entry.target);

          if (entry.isIntersecting) {
            this.$activeBlocks.add(entry.target);
          } else {
            this.$activeBlocks.delete(entry.target);
          }
        });

        if (this.$activeBlocks.size) {
          this.addProgressListeners();
          this.requestProgressUpdate();
        } else {
          this.removeProgressListeners();
        }
      });

      this.$blocks.forEach($block => this.observer.observe($block));
    },

    addProgressListeners() {
      if (this.isListening) return;

      window.addEventListener('scroll', this.onScroll, {passive: true});
      window.addEventListener('resize', this.onResize);
      this.isListening = true;
    },

    removeProgressListeners() {
      if (!this.isListening) return;

      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.isListening = false;
    },

    requestProgressUpdate() {
      if (this.ticking) return;

      this.ticking = true;

      requestAnimationFrame(() => {
        this.updateProgress();
        this.ticking = false;
      });
    },

    updateProgress($blocks = this.$activeBlocks) {
      $blocks.forEach($block => this.updateBlockProgress($block));
    },

    updateBlockProgress($block) {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const rect = $block.getBoundingClientRect();
      const progress = (viewportHeight - rect.top) / viewportHeight;
      const clampedProgress = Math.min(Math.max(progress, 0), 1);

      $block.style.setProperty('--scroll-progress', clampedProgress.toString());
    }
  };

  block.init();
})();

